export const NO_DEPARTAMENT_ID = 'no-departament';
